(function () {
  'use strict';

  angular.module('app').service('ReceivedPaymentModalService', ReceivedPaymentModalService);

  ReceivedPaymentModalService.$inject = ['ModalService'];

  function ReceivedPaymentModalService(ModalService) {
    var service = {
      openSearchOpenPayments: openSearchOpenPayments,
    };

    return service;

    ////////////////////////

    function openSearchOpenPayments(filterCriteria, receivedPaymentDocuments, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/received-payments/modals/search-open-payments-modal.html',
        controller: SearchOpenPaymentsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          filterCriteria: filterCriteria,
          receivedPaymentDocuments: receivedPaymentDocuments,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      SearchOpenPaymentsModalCtrl.$inject = [
        '$element',
        'filterCriteria',
        'receivedPaymentDocuments',
        'successCallback',
        'ReceivedPaymentService',
        'UtilService',
        'CONFIGURATIONS',
      ];
    }

    function SearchOpenPaymentsModalCtrl(
      $element,
      filterCriteria,
      receivedPaymentDocuments,
      successCallback,
      ReceivedPaymentService,
      UtilService,
      CONFIGURATIONS
    ) {
      const vm = this;

      vm.UtilService = new UtilService(vm);
      var config = CONFIGURATIONS;

      vm.modalTitle = 'OPEN_DOCUMENTS';

      vm.dateDisplay = config.DATE_DISPLAY;

      vm.selectDocument = selectDocument;

      // Initializers
      getOpenDocuments();

      function getOpenDocuments() {
        vm.loadingOpenDocuments = true;

        ReceivedPaymentService.searchOpenPayments(filterCriteria).then(function (data) {
          vm.openDocuments = vm.UtilService.getAvailableItemsInTwoArrays(
            data,
            receivedPaymentDocuments,
            'document_id'
          );

          vm.loadingOpenDocuments = false;
        });
      }

      function selectDocument(item) {
        $element.modal('hide');
        successCallback(item);
      }
    }
  }
})();
